import script from "./UserDetailPage.vue?vue&type=script&setup=true&lang=js"
export * from "./UserDetailPage.vue?vue&type=script&setup=true&lang=js"

import "./UserDetailPage.vue?vue&type=style&index=0&id=fe704986&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fe704986"]])

export default __exports__